export const fileUploadingRoomAndRoomSelector = ({ dropzone: { fileUploadingRoomAndRoom: value } }) => value;
export const refreshRoomPhotosSelector = ({ dropzone: { refreshRoomPhotos: value } }) => value;
